module.exports = __webpack_public_path__ + "media/images/icons/veiling-009ca0baad31c2e22822e81801d39c58.svg";